
export const parseDate = (phpDate: any): Date => {
  const unixTimestamp: number = (phpDate.timestamp as number)
  return new Date(unixTimestamp * 1000)
}